"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInterstitial = void 0;
const features_1 = require("../../features");
const useInterstitialBase_hook_1 = require("./useInterstitialBase.hook");
const initializer_1 = require("../../initializer");
const react_1 = require("react");
const useInterstitial = () => {
    const interstitialsRepository = (0, react_1.useRef)(new features_1.InterstitialsRepository(initializer_1.API));
    return (0, useInterstitialBase_hook_1.useInterstitialBase)(interstitialsRepository.current);
};
exports.useInterstitial = useInterstitial;
//# sourceMappingURL=useInterstitial.hook.js.map